import httpClient from "./httpClient";

const objectTemplatesGet = (objectTypesId, lang) =>
  httpClient.get(`/objectTemplates/${objectTypesId}/${lang}`);

const objectTemplatesCreate = (objectTypesId, lang, data) =>
  httpClient.post(`/objectTemplates/${objectTypesId}/${lang}`, data);

const objectTemplatesUpdate = (objectTypesId, id, lang, data) =>
  httpClient.put(`/objectTemplates/${objectTypesId}/${id}/${lang}`, data);

const objectTemplatesDelete = (objectTypesId, id) =>
  httpClient.delete(`/objectTemplates/${objectTypesId}/${id}`);

export {
  objectTemplatesGet,
  objectTemplatesCreate,
  objectTemplatesUpdate,
  objectTemplatesDelete
};
